import gql from 'graphql-tag'
import { GEO_FENCE_FIELDS } from './queries'

// Publicar/salvar cerca completa: categoryId, location e radiusMeters OBRIGATÓRIOS.
// input: { id?, name!, description?, categoryId!, location!: { lat, lng }, radiusMeters!,
//          associatedUnitIds?: [ID!], openingHours?: [{ day, active, startTime, endTime }] }
export const MUTATION_UPSERT_GEO_FENCE = gql`
  mutation UpsertGeoFence($input: UpsertGeoFenceInput!) {
    upsertGeoFence(input: $input) {
      ...GeoFenceFields
    }
  }
  ${GEO_FENCE_FIELDS}
`

// Salvar rascunho: só name obrigatório; demais nuláveis.
// input: { id?, name!, description?, categoryId?, location?, radiusMeters?, associatedUnitIds?, openingHours? }
export const MUTATION_UPSERT_GEO_FENCE_DRAFT = gql`
  mutation UpsertGeoFenceDraft($input: UpsertGeoFenceDraftInput!) {
    upsertGeoFenceDraft(input: $input) {
      ...GeoFenceFields
    }
  }
  ${GEO_FENCE_FIELDS}
`

// Ciclo de vida: ACTIVE->INACTIVE (inativar), INACTIVE->ACTIVE (reativar; backend recalcula 90d),
// DRAFT->ACTIVE (publicar via status também possível). Backend deriva expiresAt.
export const MUTATION_SET_GEO_FENCE_STATUS = gql`
  mutation SetGeoFenceStatus($id: ID!, $status: GeoFenceStatus!) {
    setGeoFenceStatus(id: $id, status: $status) {
      ...GeoFenceFields
    }
  }
  ${GEO_FENCE_FIELDS}
`

// Hard-delete: só Rascunho. Retorna Boolean!.
export const MUTATION_DELETE_GEO_FENCE = gql`
  mutation DeleteGeoFence($id: ID!) {
    deleteGeoFence(id: $id)
  }
`

// Categoria. input: { id?, name!, color! }
export const MUTATION_UPSERT_GEO_FENCE_CATEGORY = gql`
  mutation UpsertGeoFenceCategory($input: UpsertGeoFenceCategoryInput!) {
    upsertGeoFenceCategory(input: $input) {
      id
      name
      color
      isDefault
      isStore
    }
  }
`

// Retorna Boolean!; backend bloqueia (false) quando há cercas vinculadas (inclui Inativa/Expirada).
export const MUTATION_DELETE_GEO_FENCE_CATEGORY = gql`
  mutation DeleteGeoFenceCategory($id: ID!) {
    deleteGeoFenceCategory(id: $id)
  }
`

// Obs.: registerGeoFenceEvents/registerDeviceGeoFences são do app (issuer federation),
// NÃO do CBM — não declarados aqui. syncStoreGeoFences vive no starlord (admin).
